import { TaskCreateDto } from '@maia/shared';
import { service } from '@maia/task';
import { InsuranceCard, PageHeader, QuotationCard } from '@maia/ui';
import { useMutation } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { getQuotationOptions } from '../../../../features/quotation/quotation/queryOptions';
import * as v from 'valibot';
import { CreateTaskForm } from '../../../../features/task/new/form';

export const Route = createFileRoute('/_authenticated/tasks/new/quotation')({
  component: Page,
  loaderDeps: ({ search: { guid } }) => ({ guid }),
  loader: ({ context: { queryClient }, deps: { guid } }) =>
    queryClient.ensureQueryData(getQuotationOptions(guid)),
  validateSearch: v.object({
    guid: v.string(),
  }),
});

function Page() {
  const data = Route.useLoaderData();
  const navigate = useNavigate();

  const { mutate } = useMutation({
    mutationFn: (task: Omit<TaskCreateDto, 'linked_item'>) =>
      service.create({
        customerGuid: data.customer.guid,
        ...task,
        linked_item: { guid: data.guid, type: 'quotation' },
      }),
    onSuccess: ({ task_guid }) => {
      navigate({ to: `/tasks/${task_guid}` });
    },
  });

  return (
    <div className="layout-sidebar">
      <PageHeader className="area-page-header" title="Taak details invullen" />
      <div className="bg-primary50 p-32">
        <QuotationCard quotation={data} />
      </div>
      <CreateTaskForm
        linkedItem={{
          guid: data.guid,
          type: 'quotation',
        }}
        onSubmit={async (value) => mutate(value)}
      />
    </div>
  );
}
